import { render } from "./ValueOutlet.vue?vue&type=template&id=808c96a2&scoped=true&bindings={\"label\":\"props\",\"value\":\"props\",\"editable\":\"props\",\"editButtonText\":\"props\"}"
import script from "./ValueOutlet.vue?vue&type=script&lang=js"
export * from "./ValueOutlet.vue?vue&type=script&lang=js"

import "./ValueOutlet.vue?vue&type=style&index=0&id=808c96a2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-808c96a2"

export default script